// Requirement lifecycle status → the i18n catalogue KEY the client shows for it. Pass the
// result through t() (or tp()) — these are English catalogue keys, not display strings.
//
// `label` is Title Case, for a badge/heading. `word` is the same status as a lowercase word,
// for use inside a sentence ("{ref} is {word}…"). Both exist because English capitalises a
// badge and not a sentence — German and French need the distinction too (see RegisterPage.de.ts
// / .fr.ts: 'Held'/'held' are separate catalogue entries with separate translations).
//
// 'confirmed' is the STORED value — audit history refers to it, and the column is unmigrated on
// purpose (see the CHECK comment in src/server/db/schema.sql). The word "confirmed" reads as a
// two-party agreement it never was: it only ever meant "the operator has settled this". The
// CLIENT-confirmed state already exists and is called 'baselined'. So the label is "Held" /
// "held" — the same word the proposal disposition already uses (held/amended/refused): you
// hold a proposal into the register, and what is in the register is held, by you, in both
// cases. See docs/ATTEST.md.
//
// ONE mapping. Every requirement-status render site imports this — do not add a second one.
export const REQUIREMENT_STATUS_LABEL: Record<string, { label: string; word: string }> = {
  draft: { label: 'Draft', word: 'draft' },
  confirmed: { label: 'Held', word: 'held' },
  baselined: { label: 'Baselined', word: 'baselined' },
  changed: { label: 'Changed', word: 'changed' },
  delivered: { label: 'Delivered', word: 'delivered' },
  accepted: { label: 'Accepted', word: 'accepted' },
  descoped: { label: 'Out of scope', word: 'out of scope' },
};
